export const getReactModalStyle = () => ({
  '.ReactModalPortal': {
    '& .react-modal-overlay, .ReactModal__Overlay': {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1061,
      background: 'rgba(255, 255, 255, 0.4)',
    },

    '& .react-modal, .ReactModal__Content': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      padding: 24,
      outline: 'none',
      transform: 'translate(-50%, -50%)',
      marginRight: '-50%',
      background: '#fff',
      boxShadow: '0px 4.8px 14.4px rgba(0, 0, 0, 0.18), 0px 25.6px 57.6px rgba(0, 0, 0, 0.22)',
    },
  },

  reactModalButton: {
    marginRight: '12px',
  },
});
